import { ApiClient } from './client'
import { ApiService } from './service'

import { Either, Left, Right } from 'fp-ts/lib/Either'

import { ListWithPagination } from '@/models/api/response/list'
import { callWithAuth } from '@/services/auth/call-with-auth'
import { log } from '@/util/log'

const namespace: string = 'favorite_item'

// 単一FKUの操作は対象ブランドのスコープで行うため、ブランドは path に置く
const fkuEndpoint = (brandEnglishName: string, fkuId: string): string =>
  `/api/user/favorite_item/${brandEnglishName}/${fkuId}`

export default class FavoriteItemService extends ApiService {
  /**
   * FIXME: 一覧の各要素は Engine productclass2 の生データであり、
   * ProductclassService の一覧系と同様に any で返している。
   * 「一覧表示用の商品」の型を定義して利用するようにしたい
   */
  public async listWithPagination(query: object): Promise<Either<Error, ListWithPagination<any>>> {

    try {
      const response = await callWithAuth(() => ApiClient.get(`/api/user/favorite_item/list`, query))
      log.debug({ service: `${namespace}/list`, response })

      return new Right(
        ListWithPagination.createFrom(response)
      )
    } catch (error) {
      log.error({ service: `${namespace}/list`, error })

      return new Left(error)
    }
  }

  public async exists(fkuId: string, brandEnglishName: string): Promise<Either<Error, boolean>> {
    try {
      const response = await callWithAuth(() => ApiClient.get(`${fkuEndpoint(brandEnglishName, fkuId)}/exists`))
      log.debug({ service: `${namespace}/${fkuId}/exists`, response })

      return new Right(response.body.is_favorite_item)
    } catch (error) {
      log.error({ service: `${namespace}/${fkuId}/exists`, error })

      return new Left(error)
    }
  }

  /**
   * お気に入りへ追加する。すでに追加済みでも成功する（冪等）
   */
  public async add(fkuId: string, brandEnglishName: string): Promise<Either<Error, null>> {
    try {
      const response = await callWithAuth(() => ApiClient.post(fkuEndpoint(brandEnglishName, fkuId)))
      log.debug({ service: `${namespace}/add/${fkuId}`, response })

      return new Right(null)
    } catch (error) {
      log.error({ service: `${namespace}/add/${fkuId}`, error })

      return new Left(error)
    }
  }

  /**
   * お気に入りから削除する。もともと存在しなくても成功する（冪等）
   */
  public async remove(fkuId: string, brandEnglishName: string): Promise<Either<Error, null>> {
    try {
      const response = await callWithAuth(() => ApiClient.delete(fkuEndpoint(brandEnglishName, fkuId)))
      log.debug({ service: `${namespace}/remove/${fkuId}`, response })

      return new Right(null)
    } catch (error) {
      log.error({ service: `${namespace}/remove/${fkuId}`, error })

      return new Left(error)
    }
  }
}
